import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import firebaseConfig from "../firebase-applet-config.json";

export class AdminAuthError extends Error {}

/**
 * fetch para endpoints de administración: agrega el token de Firebase Auth
 * de la sesión de Google activa. El servidor lo valida con requireAdmin().
 */
export async function adminFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  const auth = getAuth(app);
  await auth.authStateReady();

  const user = auth.currentUser;
  if (!user) {
    throw new AdminAuthError("Tu sesión de Google no está activa. Tocá \"Salir\" y volvé a ingresar con Google.");
  }

  const token = await user.getIdToken();
  const headers = new Headers(init.headers);
  headers.set("Authorization", `Bearer ${token}`);

  const res = await fetch(input, { ...init, headers });
  if (res.status === 401) {
    throw new AdminAuthError("Sesión vencida. Tocá \"Salir\" y volvé a ingresar con Google.");
  }
  if (res.status === 403) {
    throw new AdminAuthError("Tu cuenta no tiene permiso para esta sección.");
  }
  return res;
}
